import cn from 'classnames';
import { InfoTitle } from '../common/InfoTooltip';
import PropTypes from 'prop-types';
import styles from './TableWrapper.module.scss';
import tableCellsStyles from './TableCells.module.scss';

export function TableWrapper(props) {
  const { hasExpandedRow, onExpandAll } = props;

  return (
    <div className={cn(styles.tableWrapper, tableCellsStyles.table, props.className)}>
      <table className={cn(styles.table, props.className)}>{props.children}</table>

      {onExpandAll ? (
        <InfoTitle content={hasExpandedRow ? 'Collapse all' : 'Expand all'}>
          <button
            className={cn(styles.buttonExpandAll, hasExpandedRow ? styles.buttonCollapseAll : '')}
            onClick={onExpandAll}
          />
        </InfoTitle>
      ) : null}
    </div>
  );
}

TableWrapper.propTypes = {
  hasExpandedRow: PropTypes.bool.isRequired,
  onExpandAll: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
